import AvailabilityCurrentUserProvider from './availabilityUser/AvailabilityCurrentUserProvider';
import FocusTimeProvider from './focusTime/FocusTimeProvider';
import { InterruptionsProvider } from './interruprions/InterruptionsContext';
import { PropsWithChildren } from 'react';
import AvailabilitySocketProvider from './socket/AvailabilitySocketProvider';
import useCurrentUserAvailability from './availabilityUser/shared/hooks/useCurrentUserAvailability';

const AvailabilityProvider = ({ children }: PropsWithChildren) => {
  const { isAvailabilityEnabled } = useCurrentUserAvailability();

  return (
    <AvailabilitySocketProvider isAvailabilityEnabled={isAvailabilityEnabled}>
      <InterruptionsProvider isAvailabilityEnabled={isAvailabilityEnabled}>
        <AvailabilityCurrentUserProvider isAvailabilityEnabled={isAvailabilityEnabled}>
          <FocusTimeProvider>{children}</FocusTimeProvider>
        </AvailabilityCurrentUserProvider>
      </InterruptionsProvider>
    </AvailabilitySocketProvider>
  );
};

export default AvailabilityProvider;
